"use client";

import {
  StatsigProvider,
  StatsigUser,
  useClientBootstrapInit,
} from "@statsig/react-bindings";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";

export default function Statsig({
  children,
  bootstrapValues,
}: Readonly<{
  bootstrapValues: { data: string; user: StatsigUser; key: string };
  children: React.ReactNode;
}>) {
  const client = useClientBootstrapInit(
    bootstrapValues.key,
    bootstrapValues.user,
    bootstrapValues.data,
    {
      plugins: [new StatsigAutoCapturePlugin()],
    },
  );

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
}
